import Image from "next/image";
import { Paragraph, Title } from "@/components/ui/typography";
import Animate from "@/components/Animate";

export default function AboutCardContent({ theme = "light", variant = "md", title, content, src }) {
  return (
    <Animate
      animation="fadeIn"
      duration={1}
      className="about-card w-full h-full relative group overflow-hidden bg-black"
    >
      <div className="absolute z-[10] bottom-[20px] px-4">
        <div>
          <Title
            className={`leading-[120%] 2xl:text-[1.21vw]  ${
              theme === "light" ? "text-system-disabled" : "text-dark"
            } pb-1`}
          >
            {title}
          </Title>
          <Paragraph
            className={`2xl:text-[0.80vw]  leading-[21px] md:leading-[25.5px]  ${
              theme === "light" ? "text-system-disabled" : "text-midnightIndigo-350"
            }`}
          >
            {content}
          </Paragraph>
        </div>
      </div>
      <Image
        height={variant === "lg" ? 680 : variant === "md" ? 425 : 225}
        width={variant === "lg" ? 590 : 425}
        src={src}
        alt={title}
        className="w-full h-full duration-300 md:h-auto md:aspect-[4/3] lg:h-full object-cover bg-black"
      />
    </Animate>
  );
}
